import { apiClientPostRequest } from '../lib/backendRequest';

const stripeApi = accessToken => ({
  /**
   * Sign payload
   *
   * @param {object} payload
   */
  async createPaymentIntent(method, amount, currency) {
    try {
      const response = await apiClientPostRequest(
        `api/v1/stripe/intent`,
        {
          amount,
          currency,
          method,
        },
        {
          Authorization: `Token ${accessToken}`,
        },
      );

      const json = await response.json();

      return { data: json.data };
    } catch (e) {
      return { error: e.body };
    }
  },
});

export default stripeApi;
